import ScanningPage from './ScanningPage';
export default ScanningPage;